// src/api/employee.api.js

import api from './axios';

export const getEmployeeUserLinkOptionsApi = () =>
  api.get('/employees/user-link-options');

export const getEmployeesApi = (page = 1, limit = 10, q = '') =>
  api.get('/employees', { params: { page, limit, q } });

export const createEmployeeApi = (payload) => api.post('/employees', payload);

export const updateEmployeeApi = (id, payload) =>
  api.put(`/employees/${id}`, payload);

export const deleteEmployeeApi = (id) => api.delete(`/employees/${id}`);
